import { Button, Flex, PasswordInput } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useCallback } from "react";

import SvgCrossedEye from "../../../components/Icons/CrossedEye.tsx";
import SvgVisibility from "../../../components/Icons/Visibility.tsx";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";

interface Props {
  submitting: boolean;
  onSubmit: (value: { password1: string; password2: string }) => void;
}

export const ChangePasswordForm = ({ submitting, onSubmit }: Props) => {
  const form = useForm({
    initialValues: {
      password1: "",
      password2: "",
    },
    validate: {
      password1: isNotEmpty("Field is required"),
      password2: isNotEmpty("Field is required"),
    },
    validateInputOnBlur: true,
  });

  const handleSubmit = useCallback(() => {
    if (!form.isValid()) {
      return;
    }
    onSubmit(form.values);
  }, [form, onSubmit]);

  return (
    <>
      <Flex direction="column" gap={12} w="35%">
        <SectionTitle flex={0} isSmall variant="golden">
          Change Password
        </SectionTitle>
        <PasswordInput
          label="Current Password"
          placeholder="********"
          size="m"
          visibilityToggleIcon={({ reveal }) =>
            reveal ? <SvgCrossedEye /> : <SvgVisibility />
          }
          {...form.getInputProps("password1")}
        />
        <PasswordInput
          label="New Password"
          placeholder="********"
          size="m"
          visibilityToggleIcon={({ reveal }) =>
            reveal ? <SvgCrossedEye /> : <SvgVisibility />
          }
          {...form.getInputProps("password2")}
        />
        <Flex justify="flex-end">
          <Button
            variant="outlineBlue"
            size="m"
            type="submit"
            uppercase
            w="50%"
            disabled={!form.isValid()}
            loading={submitting}
            onClick={handleSubmit}
          >
            save
          </Button>
        </Flex>
      </Flex>
    </>
  );
};
